export default {"src":"/_next/static/media/external-link.0b86e490.svg","height":16,"width":16};